import Swiper, {
    Autoplay,
    Navigation,
    Pagination,
    Thumbs,
} from 'swiper'
Swiper.use([Autoplay, Navigation, Pagination, Thumbs])



// WEBPACK FOOTER //
// ./scripts/custom/swiper.js